import initialState from './initialState';
import { reducer as setOnwardPbDateReducer } from './setOnwardPbDate';
import { reducer as setReturnPbDateReducer } from './setReturnPbDate';
import { reducer as pbSetSourceCityReducer } from './pbSetSourceCity';
import { reducer as pbSetDestinationCityReducer } from './pbSetDestinationCity';
import { reducer as getMetaDataReducer } from './getMetaData';
import { reducer as getUniqueCitiesReducer } from './getUniqueCities';
import { reducer as setHomeStateReducer } from './setHomeState';
import { reducer as setTransferDataReducer } from './setTransferData';
import { reducer as pbSetTypeReducer } from './pbSetType';
import { reducer as setKuposGoDataReducer } from './setKuposGoData';
import { reducer as kuposGoPostTripDetailsReducer } from './kuposGoPostTripDetails';
import { reducer as resetNewPasswordReducer } from './resetNewPassword';
import { reducer as accountConfirmationReducer } from './accountConfirmation';
import { reducer as setSearchAppReducer } from './setSearchApp';
import { reducer as apiCallReducer } from './apiCall';
import { reducer as setTerminalsReducer } from './setTerminals';
import { reducer as getSiteMapReducer } from './getSiteMap';
import { reducer as setSiteMapDataReducer } from './setSiteMapData';
import { reducer as setAtMastersDataReducer } from './setAtMastersData';
import { reducer as setMetaDataReducer } from './setMetaData';
import { reducer as setStagesReducer } from './setStagesData';
import { reducer as setIsMotDataReducer } from './setIsMot';
import { reducer as setCuponeraSeatsReducer } from './setCuponeraSeats';

const reducers = [
  setOnwardPbDateReducer,
  setReturnPbDateReducer,
  pbSetSourceCityReducer,
  pbSetDestinationCityReducer,
  getMetaDataReducer,
  getUniqueCitiesReducer,
  setHomeStateReducer,
  setTransferDataReducer,
  pbSetTypeReducer,
  setKuposGoDataReducer,
  kuposGoPostTripDetailsReducer,
  resetNewPasswordReducer,
  accountConfirmationReducer,
  setSearchAppReducer,
  apiCallReducer,
  setTerminalsReducer,
  getSiteMapReducer,
  setSiteMapDataReducer,
  setAtMastersDataReducer,
  setMetaDataReducer,
  setStagesReducer,
  setIsMotDataReducer,
  setCuponeraSeatsReducer,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    // Handle cross-topic actions here
    default:
      newState = state;
      break;
  }
  /* istanbul ignore next */
  return reducers.reduce((s, r) => r(s, action), newState);
}



// WEBPACK FOOTER //
// ./src/features/home/redux/reducer.js